/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore', 'assets/js/modules/pricing/pricingFactory'], function(backbone, _, pricingFactory) {
    var OptionValueModel;

    return (OptionValueModel = backbone.Model.extend(
        {
            defaults: {
                name: null,
                title: null,
                enabled: false,
                description: null,
                default: false,
                visible: true,
                /** @var {PricingModel} pricing */
                pricing: null,
                optionValueDependencies: [],
                optionValueRequirements: [],
                optionValueConflicts: [],
                skuConflicts: [],

                selected: false,
                isAlert: false
            },

            /**
             * @param {Object} dto
             * @returns {OptionValueModel}
             */
            fromDTO: function(dto) {
                var _this = this;
                _.each(OptionValueModel.DTOMap, function(mappedName, attributeName) {
                    if (dto[mappedName] !== undefined) {
                        if (attributeName === 'skuConflicts') {
                            dto[mappedName] = _.map(dto[mappedName], function(sku) {
                                return parseInt(sku);
                            });
                        }
                        if (attributeName === 'pricing') {
                            dto[mappedName] = pricingFactory.fromDTO(dto[mappedName]);
                        }
                        _this.set(attributeName, dto[mappedName]);
                    }
                });
                return this;
            },

            /**
             * @returns {Array}
             */
            getFrontFoilColors: function() {
                return [OptionValueModel.NAME_FRONT_FOIL_SILVER, OptionValueModel.NAME_FRONT_FOIL_GOLD];
            },

            /**
             * @returns {Array}
             */
            getBackFoilColors: function() {
                return [OptionValueModel.NAME_BACK_FOIL_SILVER, OptionValueModel.NAME_BACK_FOIL_GOLD];
            },

            /**
             * @param {string} foilColor
             * @returns {boolean}
             */
            hasFrontFoilColor: function(foilColor) {
                return this.getFrontFoilColors().includes(foilColor);
            },

            /**
             * @param {string} foilColor
             * @returns {boolean}
             */
            hasBackFoilColor: function(foilColor) {
                return this.getBackFoilColors().includes(foilColor);
            },

            /**
             * @param {string} name
             * @returns {string}
             */
            getCoatingTitle: function(name) {
                switch (name) {
                    case OptionValueModel.NAME_FRONT_COATING_FULL_UV:
                    case OptionValueModel.NAME_BACK_COATING_FULL_UV:
                        return 'Full Gloss Coating';
                    case OptionValueModel.NAME_FRONT_COATING_SPOT_UV:
                    case OptionValueModel.NAME_BACK_COATING_SPOT_UV:
                        return 'Spot UV Coating';
                    case OptionValueModel.NAME_FRONT_COATING_SOFT_TOUCH_LAMINATE:
                    case OptionValueModel.NAME_BACK_COATING_SOFT_TOUCH_LAMINATE:
                        return 'Soft Touch Laminate';
                    case OptionValueModel.NAME_FRONT_COATING_TEXTURE:
                    case OptionValueModel.NAME_BACK_COATING_TEXTURE:
                        return 'Texture';
                    case OptionValueModel.NAME_FRONT_COATING_FOIL:
                    case OptionValueModel.NAME_BACK_COATING_FOIL:
                        return 'Foil Coating';
                    case OptionValueModel.NAME_FRONT_COATING_NONE:
                    case OptionValueModel.NAME_BACK_COATING_NONE:
                    default:
                        return 'Satin Matte Finish';
                }
            }
        },
        {
            DTOMap: {
                name: 'name',
                title: 'title',
                description: 'description',
                enabled: 'enabled',
                default: 'default',
                visible: 'visible',
                pricing: 'pricing',
                optionValueConflicts: 'option_value_conflicts_with',
                optionValueDependencies: 'option_value_depends_on',
                optionValueRequirements: 'option_value_required_by',
                skuConflicts: 'sku_conflicts_with'
            },

            NAME_MAILING_SERVICE: 'mailing_service',
            NAME_NONE_MAILING_SERVICE: 'none_mailing_service',
            NAME_ROUNDED_CORNERS: 'rc',
            NAME_SQUARE_CORNERS: 'square_corners',
            NAME_HOLE_DRILLING: 'hole_drilling',
            NAME_NONE_HOLE_DRILLING: 'none_hole_drilling',
            NAME_TRIMMING: 'trimming',
            NAME_NONE_TRIMMING: 'none_trimming',
            NAME_GREEN_ENV: 'green_env',
            NAME_RED_ENV: 'red_env',
            NAME_WHITE_ENV: 'white_env',
            NAME_BLUE_ENV: 'blue_env',
            NAME_NONE_ENV: 'no_env',
            NAME_NONE_FOLD: 'none_folding',
            NAME_BI_FOLD: 'bi_fold',
            NAME_TRI_FOLD: 'tri_fold',
            NAME_Z_FOLD: 'z_fold',
            NAME_SCORING_BI_FOLD: 'scoring_bi_fold',
            NAME_SINGLE_THICKNESS: 'single_thickness',
            NAME_FRONT_COATING_NONE: 'front_coating_none',
            NAME_FRONT_COATING_FULL_UV: 'front_coating_full_uv',
            NAME_FRONT_COATING_SPOT_UV: 'front_coating_spot_uv',
            NAME_FRONT_COATING_SOFT_TOUCH_LAMINATE: 'front_coating_soft_touch_laminate',
            NAME_FRONT_COATING_TEXTURE: 'front_coating_texture',
            NAME_FRONT_COATING_FOIL: 'front_coating_foil',
            NAME_BACK_COATING_NONE: 'back_coating_none',
            NAME_BACK_COATING_FULL_UV: 'back_coating_full_uv',
            NAME_BACK_COATING_SPOT_UV: 'back_coating_spot_uv',
            NAME_BACK_COATING_SOFT_TOUCH_LAMINATE: 'back_coating_soft_touch_laminate',
            NAME_BACK_COATING_FOIL: 'back_coating_foil',
            NAME_UPLOAD_PATTERN_NONE: 'upload_pattern_none',
            NAME_UPLOAD_PATTERN_TILE: 'upload_pattern_tile',
            NAME_BACK_COATING_TEXTURE: 'back_coating_texture',
            NAME_CUSTOM_FOLDING: 'custom_folding',
            NAME_FOAM_BOARD: 'foam_board',
            NAME_NONE_COVER_COATING: 'none_cover_coating',
            NAME_COVER_FULL_COATING: 'cover_full_coating',
            NAME_100_AQUEOUS_FINISH: '100_aqueous_finish',
            NAME_150GSM_ILLUSTRATON: '150gsm_illustration',
            NAME_250GSM_ILLUSTRATON: '250gsm_illustration',
            NAME_350GSM_ILLUSTRATON: '350gsm_illustration',
            NAME_100LBS_SINGLE_SANDWICH_CARD_STOCK: '100lbs_accent_opaque',
            NAME_100LBS_DOUBLE_SANDWICH_CARD_STOCK: '100lbs_accent_opaque_double',
            NAME_VANILLA_FLAVOR: 'vanilla',
            NAME_CHOCOLATE_FLAVOR: 'chocolate',
            NAME_PISTACHIO_FLAVOR: 'pistachio',
            NAME_RASPBERRY_FLAVOR: 'raspberry',
            NAME_FRONT_FOIL_SILVER: 'front_foil_silver',
            NAME_FRONT_FOIL_GOLD: 'front_foil_gold',
            NAME_BACK_FOIL_SILVER: 'back_foil_silver',
            NAME_BACK_FOIL_GOLD: 'back_foil_gold',

            MACARON_FLAVOR_COLORS: {
                raspberry: '#fba6ab',
                pistachio: '#c6e28d',
                chocolate: '#bc7645',
                vanilla: '#f1e4af'
            }
        }
    ));
});
